import type { EnumLearningPlan, UserStudyPlanInfo } from '@crehana/web';

export const chooseProgressState = (
  plans: UserStudyPlanInfo | undefined,
): EnumLearningPlan => {
  // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
  if (!plans?.progress || plans?.progress.percent <= 0) return 'empty';
  // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
  if (plans?.progress.percent < 25) return 'alert';
  // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
  if (plans?.progress.percent < 50) return 'warning';
  // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
  if (plans?.progress.percent <= 99) return 'success';
  // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
  if (plans?.progress.percent === 100) return 'completed';
  return 'completed';
};

export const formatAcademyImage = (imageURL: string): string => {
  if (!imageURL.startsWith('https:')) {
    return `https://s3.amazonaws.com/public-catalog.crehana.com/${imageURL}`;
  }

  return imageURL;
};
